module.exports = __webpack_public_path__ + "static/img/mep-bg5.683fb422.png";